import vendorStatusService from "../../../../services/procurementService/vendorStatusService";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { CACHE_KEY_VENDORSTATUSES } from "../../../../utils/constants";
import { VendorStatusInterface } from "../../../../models/ProcurementModule/VendorStatus";

interface DeleteVendorStatusContext {
  previousVendorStatuses: VendorStatusInterface[];
  deletedVendorStatus: VendorStatusInterface | undefined;
}

const useDeleteVendorStatus = (page: number, pageSize: number) => {
  const queryClient = useQueryClient();

  return useMutation<
    void, // No return data after deletion
    Error,
    string, // ID of the customer to delete
    DeleteVendorStatusContext
  >({
    mutationFn: vendorStatusService.Remove, // Remove should take a string ID

    onMutate: (vendorStatusId: string) => {
      const previousVendorStatuses =
        queryClient.getQueryData<VendorStatusInterface[]>([
          CACHE_KEY_VENDORSTATUSES,
          page,
          pageSize,
        ]) || [];

      // Optimistically update the cache
      queryClient.setQueryData<VendorStatusInterface[]>(
        [CACHE_KEY_VENDORSTATUSES, page, pageSize],
        previousVendorStatuses.filter(
          (vendorStatus) => vendorStatus.id !== vendorStatusId
        ) // Use statusId to filter
      );

      return {
        previousVendorStatuses,
        deletedVendorStatus: previousVendorStatuses.find(
          (vendorStatus) => vendorStatus.id === vendorStatusId
        ),
      };
    },

    onError: (error, vendorStatusId, context) => {
      if (!context) return;

      // Rollback to the previous state in case of error
      queryClient.setQueryData<VendorStatusInterface[]>(
        [CACHE_KEY_VENDORSTATUSES, page, pageSize],
        context.previousVendorStatuses
      );
    },

    onSuccess: () => {
      // Optionally, you could perform additional actions on success
      // For example, invalidating queries or updating other parts of the state
    },
  });
};

export default useDeleteVendorStatus;
